import { Vue, sessionManager, Logger } from 'vue-infra';
import PortalVue from 'portal-vue';
import routes from './router/routes';
import { appCode, appName } from '../config';

const appStore = r => require.ensure([], () => r(require('./store')), 'appStore');
const AppComponent = r => require.ensure([], () => r(require('./App.vue')), 'AppComponent');
const logger = Logger.getLogger('agentSurveys');

const VIEW_LE_SKILL_LIST_PRIVILEGE_ID = 1701;
const VIEW_MESSAGING_AGENT_SURVEY_CONFIGURATION_PRIVILEGE_ID = 1796;

if (window._) {
  window._.noConflict();
}

const config = {

  id: appName,

  moduleName: appName,

  routePrefix: appCode,

  personaMapping: appName,

  personas: ['agent', 'agentManager', 'admin', appName],

  // @deprecated - will be removed in LE 10.9
  external: true,
  // @deprecated - will be removed in LE 10.9
  regionId: `${appName}-external`,
  // @deprecated - will be removed in LE 10.9
  container: 'work-area-wrapper',
  // @deprecated - will be removed in LE 10.9
  template: 'workAreaItemNoLEClass',
};

// todo - add an example implementation with permission validation from live-engage
const shouldInitialize = ({ auth = true } = {}) => {
  if (auth) {
    return true;
  }
  return false;
};

function loadInContext(filename) {
  return new Promise((resolve) => {
    if (filename === 'en-US') {
      // en-US is excluded from bundle-loader and pre-loaded by default
      require([`./i18n/dictionaries/${filename}.json`], resolve);
    } else {
      // all other locals are loaded dynamically using the bundle-loader
      require(`./i18n/dictionaries/${filename}.json`)((dict) => {
        resolve(dict);
      });
    }
  });
}

async function loadLocal(locale, fallbackLocale) {
  const local = {};
  // load custom local
  try {
    local.localResource = await loadInContext(locale);
  } catch (e) {
    logger.error(`fail to load dictionary ${locale}`);
  }
  // load fallback local
  if (locale !== fallbackLocale) {
    try {
      local.fallbackLocaleResource = await loadInContext(fallbackLocale);
    } catch (e) {
      logger.error(`fail to load dictionary ${fallbackLocale}`);
    }
  }
  return local;
}
const registerAppComponent = () => {
  // register the component globally to get the Vue.js dev-tools working.
  // the registration name must be the same as config.routePrefix, in order for the component to load property.
  Vue.use(PortalVue, {
    portalName: 'as-portal',
    portalTargetName: 'as-portal-target',
  });
  Vue.component(appCode, {
    template: '<App/>',
    components: {
      App: AppComponent,
    },
  });
};

const applicationInit = async (leAppConfig) => {
  if (!shouldInitialize(leAppConfig)) {
    return {};
  }

  if (canViewByPrivilege() && hasAgentSurveyFeature()) {
    appStore(() => {
    });

    registerAppComponent();
    const locale = await loadLocal(leAppConfig.locale, leAppConfig.fallbackLocale ||
      leAppConfig.defaultLocale); // leConfig.defaultLocale will deprecate at LE 10.8

    return {
      i18nResource: locale.localResource, // will deprecate at LE 10.8
      fallbackI18nResource: locale.fallbackLocaleResource, // will deprecate at LE 10.8
      appLocaleResource: locale.localResource,
      appFallbackLocaleResource: locale.fallbackLocaleResource,
      routes,
      appId: appCode,
    };
  }
  return {};
};

const hasAgentSurveyFeature = () => {
  const featureName = 'Messaging.Agent_Survey';
  const agentSurveyFeature = sessionManager.getFeatureProperty(featureName);
  return agentSurveyFeature && agentSurveyFeature.value && agentSurveyFeature.value.value;
};

const canViewByPrivilege = () => {
  const hasViewSkillPagePrivilege = sessionManager.hasPrivilege(VIEW_LE_SKILL_LIST_PRIVILEGE_ID);
  const hasViewMessagingAgentSurveyConfigurationPrivilege = sessionManager.hasPrivilege(VIEW_MESSAGING_AGENT_SURVEY_CONFIGURATION_PRIVILEGE_ID);
  return hasViewSkillPagePrivilege && hasViewMessagingAgentSurveyConfigurationPrivilege;
};


const webpackPathInit = (leAppConfig) => {
  __webpack_public_path__ = leAppConfig.publicPath; // eslint-disable-line
};


export default {
  config,
  // todo - rename to 'initialize'
  applicationInit,
  // todo - rename as lifecycle hook: 'on[Something]', i.e. according to the invoked LE lifecycle event.
  // todo - suggestions: onBootstrap, onAppsLoad
  webpackPathInit,
};
